import { gql } from "@apollo/client";
import { useResettableMutation } from "../useResettableMutation";
import { getErrors } from "../../utils/apolloError";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { CompletePermitToDig, CompletePermitToDigVariables } from "./__generated__/CompletePermitToDig";
import { PERMIT_TO_DIG_ALL_FIELDS } from "../fragments/permitToDig";

const COMPLETE_PERMIT = gql`
  ${PERMIT_TO_DIG_ALL_FIELDS}
  mutation CompletePermitToDig($id: String!, $permitRegisterId: String!, $permitTypeId: String!) {
    completePermitToDig(input: { id: $id, permitRegisterId: $permitRegisterId, permitTypeId: $permitTypeId }) {
      permitToDig {
        ...PermitToDigAllFields
      }
    }
  }
`;

export function useCompletePermit() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    CompletePermitToDig,
    CompletePermitToDigVariables
  >(COMPLETE_PERMIT, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
